export enum ExpertField {
  BUDDHISM = "buddhism",
  HEALTH = "health",
  NUTRITION = "nutrition",
  PSYCHOLOGY = "psychology",
  EDUCATION = "education",
  PARENTING = "parenting",
  MEDITATION = "meditation",
  PHILOSOPHY = "philosophy",
  SCIENCE = "science",
  ARTS = "arts",
  LITERATURE = "literature",
  HISTORY = "history",
  TECHNOLOGY = "technology",
  BUSINESS = "business",
  FINANCE = "finance",
  ENVIRONMENT = "environment",
  GENERAL = "general"
}

export interface Expert {
  id: string;
  name: string;
  title?: string;
  field: ExpertField;
  avatar?: string;
  avatarUrl?: string;
  systemPrompt?: string;
  description?: string;
  biography?: string;
  qualifications?: string[];
  specialties?: string[];
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
  personality?: {
    tone?: string;
    style?: string;
    traits?: string[];
  };
  greeting?: string;
  promptPrefix?: string;
  active?: boolean;
  featured?: boolean;
}

// Các giọng điệu
export enum ExpertTone {
  FORMAL = "formal",
  FRIENDLY = "friendly",
  HUMOROUS = "humorous",
  WISE = "wise",
  STRICT = "strict",
  COMPASSIONATE = "compassionate",
  ENTHUSIASTIC = "enthusiastic",
  CALM = "calm",
  POETIC = "poetic",
  ANALYTICAL = "analytical"
}

// Các phong cách
export enum ExpertStyle {
  ACADEMIC = "academic",
  PRACTICAL = "practical",
  STORYTELLING = "storytelling",
  QUESTIONING = "questioning",
  SOCRATIC = "socratic",
  DIRECT = "direct",
  METAPHORICAL = "metaphorical",
  INSPIRATIONAL = "inspirational",
  STEP_BY_STEP = "step_by_step",
  CONVERSATIONAL = "conversational",
  PHILOSOPHICAL = "philosophical"
}

// Các đặc điểm tính cách
export enum ExpertTrait {
  PATIENT = "patient",
  WISE = "wise",
  HUMOROUS = "humorous",
  SERIOUS = "serious",
  EMPATHETIC = "empathetic",
  ENCOURAGING = "encouraging",
  CHALLENGING = "challenging",
  REFLECTIVE = "reflective",
  CREATIVE = "creative",
  LOGICAL = "logical",
  DETAIL_ORIENTED = "detail_oriented",
  BIG_PICTURE = "big_picture",
  COMPASSIONATE = "compassionate"
}

// Mẫu chuyên gia mặc định
export const DEFAULT_EXPERT: Expert = {
  id: "default",
  name: "Thiền Sư AI",
  title: "Thiền Sư",
  field: ExpertField.BUDDHISM,
  avatar: "https://imagedelivery.net/meCI2KDHmnUhVs_SxNm-Og/a1d82958-cc6f-4bdc-ce0b-25bdc7b27500/public",
  description: "Thiền sư với kiến thức sâu rộng về Phật pháp, luôn sẵn sàng hướng dẫn bạn trên con đường tu tập.",
  personality: {
    tone: ExpertTone.WISE,
    style: ExpertStyle.METAPHORICAL,
    traits: [ExpertTrait.PATIENT, ExpertTrait.WISE, ExpertTrait.EMPATHETIC]
  },
  greeting: "Chào con! Thầy là Thiền Sư AI, người đồng hành trên con đường tìm hiểu Phật pháp của con. Con có điều gì muốn hỏi về thiền định, giáo lý hay thực hành không?",
  systemPrompt: "Bạn là một thiền sư Phật giáo đang hướng dẫn học viên. Hãy trả lời câu hỏi của học viên dựa trên nội dung bài học, với giọng điệu từ bi, khôn ngoan nhưng dễ hiểu. Nếu câu hỏi nằm ngoài phạm vi bài học, hãy nhẹ nhàng hướng học viên quay lại nội dung bài học. Sử dụng các ví dụ thực tế và ngôn ngữ dễ hiểu để giải thích các khái niệm phức tạp.",
  promptPrefix: "Dưới đây là câu hỏi của học viên về bài học. Hãy trả lời với tư cách là một thiền sư Phật giáo, giọng điệu từ bi, khôn ngoan nhưng dễ hiểu. Câu hỏi: ",
  active: true,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString()
};

// Dữ liệu mẫu cho các chuyên gia
export const EXPERTS_DATA: Expert[] = [
  // Chuyên gia mặc định
  DEFAULT_EXPERT
]; 